import { render, staticRenderFns } from "./crmTicketMange.vue?vue&type=template&id=39469720"
import script from "./crmTicketMange.vue?vue&type=script&lang=js"
export * from "./crmTicketMange.vue?vue&type=script&lang=js"
import style0 from "./crmTicketMange.vue?vue&type=style&index=0&id=39469720&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports